class Lab {
  constructor () {
    this.at_store = localStorage.getItem('at_store')
    this.at_lab = localStorage.getItem('at_lab')
    this.is_registered = localStorage.getItem('is_registered')
    this.cart_items = localStorage.getItem('cart_items')
    if(localStorage.getItem('lab_google_form') == 'true') {
      this.cf_action = 'https://docs.google.com/forms/u/1/d/e/1FAIpQLSfaZi2lZpic5jErt-o2Q_nOiPcm4aCsXbWsa-de9V8KJDcOuQ/formResponse'
    } else {
      this.cf_action = 'https://docs.google.com/forms/d/e/1FAIpQLSdPE5y2CqXorhNAt2N6RfVmn5TWVWX4R_5mYEva9SYxfEZafw/formResponse'
    }
    
    this.home = '/pages/jfioewjrf898ry298ry3298ryh298hf32f2fj0239j'
    this.home_collection = '/collections/店頭受取用'
    this.$input = null
    this.form_data = {}
    this.errors = []
    this.window = null
  }

  redirectToHome() {
    location.href = this.home
    return
  }

  setInput ($input) {
    this.$input = $input
  }

  setStyles () {
    if (lab.atStore()) {
      $('.js-show-at-lab').show()
      $('.js-show-at-ec').hide()
    } else {
      $('.js-show-at-lab').hide()
      $('.js-show-at-ec').show()
    }
  }

  setStore () {
    if (this.atStore()) {
      // スタイル設定
      // $('.dl-header').css('display', 'none')
      // $('.dl-footer').css('display', 'none')
      $('.header-new').css('display', 'block')
      $('.footer-new').css('display', 'none')
      $('.sp-only > .footer-new').css('display', 'block')
      $('.header__inner > .nav-main').css('visibility', 'hidden')
      $("body").addClass("at-lab");

      // redirect
      if (location.pathname === '/') {
        location.href = this.home_collection
      }
    } else {
      $('.header-new').css('display', 'none')
      $('.footer-new').css('display', 'none')
    }
  }

  setAtStore (b) {
    localStorage.setItem('at_store', b)
    this.at_store = localStorage.getItem('at_store')
  }

  setAtLab (b) {
    localStorage.setItem('at_lab', b)
    this.at_lab = localStorage.getItem('at_lab')
  }

  setIsRegistered (isRegistered) {
    localStorage.setItem('is_registered', isRegistered)
  }

  setCartItems (items) {
    localStorage.setItem('cart_items', JSON.stringify(items))
    this.cart_items = items
  }

  isRegistered () {
    return this.is_registered === 'true'
  }

  getCartItems () {
    return JSON.parse(this.cart_items)
  }

  atStore () {
    return this.at_store === 'true'
  }

  atLab () {
    return this.at_lab === 'true'
  }

  getReceiptNo () {
    var date = new Date()
    var ts = date.getTime() + ''
    console.log(ts.slice(0, 4) + '-' + ts.slice(4, 8) + '-' + ts.slice(8))
    return ts.slice(0, 4) + '-' + ts.slice(4, 8) + '-' + ts.slice(8)
  }

  getDesignText () {
    var cartItems = this.getCartItems()
    var tmp = []

    if (!cartItems) {
      lab.redirectToHome()
      return false
    }

    cartItems.forEach(function (item, key) {
      for(let key in item.properties){
        if(key == '_boldOptionLocalStorageId') {
          delete item.properties._boldOptionLocalStorageId
        }
        if(key == '__optionVariantId') {
          delete item.properties.__optionVariantId
        }
        if(key == '__optionVariantId') {
          delete item.properties.__optionVariantId
        }
        if(key == '__optionPrice') {
          delete item.properties.__optionPrice
        }
        if(key == '__items_key') {
          delete item.properties.__items_key
        }
      }

      // 加工代は追加しない（KINTO810）
      if(!item.title.includes("加工代 - ")){
        tmp.push({
          title: item.title,
          quantity: item.quantity,
          properties: item.properties
        })
      }
      
      // const products = this.form_data;
      // const filteredProducts = products.filter(product => {
      //  return !(product.title.includes("加工代 - ") && product.properties === null);
      // });

    })

    return JSON.stringify(tmp)
  }

  getProductsInfo () {
    var items = this.getCartItems()
    var ret = []
    items.forEach(item => {
      ret.push({
        variant_id: item.variant_id,
        quantity: item.quantity
      })
    })

    return JSON.stringify(ret)
  }

  validateCF () {
    console.log(this.form_data)
    this.errors = []

    for (var key in this.form_data) {
      var value = this.form_data[key]

      // 全て必須
      if (!value) {
        var message = key === 'entry.271857161' ? '選択してください。' : '入力してください。'
        this.errors.push({
          key: key,
          message: message
        })
      }
    }

    return this.errors.length < 1
  }

  setErrors () {
    this.$input.removeClass('error')
    this.errors.forEach(error => {
      $('input[name="' + error.key + '"]').addClass('error')
      if (error.key.indexOf('_year') !== 0 || error.key.indexOf('_month') !== 0 || error.key.indexOf('_day') !== 0) {
        var k = error.key.replace('_year', '').replace('_month', '').replace('_day', '')
        $('input[name="' + k + '"]').addClass('error')
      }
    })
  }

  form2obj () {
    var data = {}

    this.$input.each(function (key, val) {
      var $val = $(val)

      if ($val.attr('type') === 'radio') {
        if (!data[val.name]) {
          data[val.name] = ''
        }

        if ($val.prop('checked')) {
          data[val.name] = $val.val() || data[val.name]
        }

        return true
      }

      if (val.name.indexOf('entry.') === 0) {
        data[val.name] = $val.val()
      }
    })

    this.form_data = data
  }

  submitCF (cb) {
    $.ajax({
      url: this.cf_action,
      type: 'POST',
      data: this.form_data,
      dataType: 'xml',
      statusCode: {
        0: function (arg1) {
          console.log('success')
        },
        200: function (arg1) {
          console.log('error')
          alert('エラーが発生しました。お手数ですが再度お試しください。')
        }
      }
    })
  }

  confirm () {
    location.hash = '#confirm'
    var formData = this.form_data

    this.$input.each(function (key, input) {
      var $input = $(input)

      var name = $input.attr('name')

      if (!name) {
        return true
      }

      if ($input.attr('type') === 'radio') {
        $input.parent('label').hide()
      }

      $('#' + $input.attr('name').replace('.', '-')).text(formData[$input.attr('name')])
    })
  }

  clean () {
    lab.cleanLocalStorage()
    lab.cleanCookie()
  }

  cleanLocalStorage () {
    localStorage.clear()
    sessionStorage.clear()
  }

  cleanCookie () {
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      if (cookieName === 'storefront_digest') {
        return true
      }
      Cookies.remove(cookieName)
    })
  }

  setNoteAttributes (form) {
    var hidden = document.createElement('input')
    hidden.type = 'hidden'
    hidden.name = 'attributes[lab注文]'
    hidden.value = this.atLab() ? 'YES' : 'NO'

    form.appendChild(hidden)
  }

  setDateOfReceipt (holidaysUrl, $view, $input) {
    $.ajax({
      url: holidaysUrl
    }).then(res => {
      var min = this.getBusinessDate(dayjs().format('YYYY-MM-DD'), 2, 'after', res)
      var max = this.getBusinessDate(dayjs(min).format('YYYY-MM-DD'), 5, 'after', res)

      var days = {
        0: '日',
        1: '月',
        2: '火',
        3: '水',
        4: '木',
        5: '金',
        6: '土'
      }

      var dMin = dayjs(min)
      var dMinD = days[dMin.format('d')]
      var dMax = dayjs(max)
      var dMaxD = days[dMax.format('d')]

      var str = `${dayjs(min).format(`YYYY年MM月DD日(${dMinD})`)} 〜 ${dayjs(max).format(`YYYY年MM月DD日(${dMaxD})`)} `

      var types = $(".product-types-validate").attr("data-type");
      if(types === "tumbler"){
      }else if(types === "bottle"){
        str = "お支払い後、その場でお渡し"
      }else if(types === "both"){
        str = str + "<br><br><span>*樹脂製ボトルのみ、お支払い後その場でお渡し</span>"
      }

      $view.html(str)
      str = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
      $input.val(str)
    }).catch(function (error) {
      console.log(error)
    })
  }

  /**
   * 起算日からn営業日前後の日付を取得する
   *
   * @param string date
   * @param int n
   * @param string ba 'before' or 'after'
   * @return string
   */
  getBusinessDate (date, n, ba, holidays) {
    var d = dayjs(date)
    var cnt = 1

    while (true) {
      if (ba === 'before') {
        d = d.add(-1, 'day')
      } else {
        d = d.add(1, 'day')
      }

      if (this.isHoliday(d.format('YYYY-MM-DD'), holidays)) {
        continue
      }

      if (cnt++ >= n) {
        break
      }
    }

    return d.format('YYYY-MM-DD')
  }

  isHoliday (date, holidays) {
    var objDate = dayjs(date)
    var dayofWeek = objDate.day()
    var holiday

    // 土日は休日
    // if (dayofWeek === 4) {
    //   return true
    // }

    // 祝日
    var ret = false

    holidays.forEach(holiday => {
      if (objDate.month() + 1 === parseInt(holiday.month) && objDate.date() === parseInt(holiday.date)) {
        ret = true
        return false
      }
    })

    return ret
  }
}

var lab = new Lab()

if (location.pathname === '/collections/%E5%BA%97%E9%A0%AD%E5%8F%97%E5%8F%96%E7%94%A8') {
  lab.setAtStore(true)
  lab.setAtLab(true)
  if (location.search === '?is_registered=true') {
    lab.setIsRegistered(true)
  } else {
    lab.setIsRegistered(false)
  }
}

$(function () {
  var product_url = localStorage.getItem("product_url");
  //console.log('product URL',product_url)
  // 店頭用のスタイル設定
  lab.setStyles()
  lab.setStore()
  lab.setInput($('input'))

  // 「注文をやめてトップへ戻る」
  // $('.js-lab-back').on('click', function (e) {
  //   e.preventDefault()
  //   lab.clean()
  //   window.close()
  //   lab.redirectToHome()
  //   return false
  // })

  $('.js-clear-cookies').on('click', function (e) {
    e.preventDefault()
    lab.cleanCookie()
  })

  /****************************
   * labでの配送注文用
   ****************************/
  var $lf = $('.page-lf')
  if ($lf.length > 0) {
    lab.setAtLab(true)
    lab.setAtStore(false)
    location.href = '/'
  }

  /****************************
   * 店舗トップページ
   ****************************/
  var $si = $('.page-si')
  if ($si.length > 0) {
    // 「店頭受け取り」の場合は次の選択肢を表示
    $('.js-lab2lab').on('click', function (e) {
      e.preventDefault()

      $('.js-hide-lab2lab').hide()
      $('.js-show-lab2lab').show()
    })

    // 会員登録して注文
    $('.js-register-next').on('click', function (e) {
      e.preventDefault()
      $('#js-register-modal').modal()
    })

    // 「既存会員として注文」
    $('.js-customer-next').on('click', function (e) {
      e.preventDefault()
      lab.clean()
      lab.setIsRegistered(true)
      lab.setAtLab(true)
      lab.setAtStore(true)
      window.open(lab.home_collection + '?is_registered=true', 'lab')
      location.reload()
    })

    $('.js-noncustomer-next').on('click', function (e) {
      e.preventDefault()
      lab.clean()
      lab.setIsRegistered(false)
      lab.setAtLab(true)
      lab.setAtStore(true)
      window.open(lab.home_collection + '?is_registered=false', 'lab')
      location.reload()
    })
  }

  /****************************
   * カートページ
   ****************************/
  var $ct = $('.page-cart')
  if ($ct.length > 0) {
    lab.setNoteAttributes(document.getElementsByClassName('js-cdd-form-cart')[0])

    // スタイル
    if (lab.atStore()) {
      $('.remarks_note_label').hide()
      $('.remarks_note').hide()
      $('.section-recently-viewed').hide()
      $('.side-container .form__aside').hide()
      $('.js-to-gform').show()
      $('.js-show-in-lab').show()
      $('.js-hide-in-lab').hide()
      $('.form-wrapper-lab').addClass("form-wrapper-lab-lab")
      $('.form-table-lab').addClass("form-table-lab-lab")
      $('.form-checkout-lab').addClass("form-checkout-lab-lab")
      $('.form-quantity-lab').addClass("form-quantity-lab-lab")
    }

    // お客様情報入力画面へ
    $('.js-gform').on('click', function () {
      lab.setCartItems($(this).data('items'))
      location.href = '/pages/customer_form'
    })
  }

  /****************************
   * お客様情報入力ページ
   ****************************/
  var $cf = $('.page-cf')
  if ($cf.length > 0) {
    // 日時の整形
    $('#js-input-date').on('change', function () {
      var tmp = $(this).val().split('-')
      $('#js-year-1').val(tmp[0])
      $('#js-month-1').val(tmp[1])
      $('#js-day-1').val(tmp[2])
    })

    // 希望引き取り日の選択肢設定
    lab.setDateOfReceipt($('#js-holidays-url').val(), $('#js-pickup-period'), $('#js-input-date'))

    // 「会員登録」の初期値
    var defaultRadio = '未登録'
    if (lab.isRegistered()) {
      defaultRadio = '登録済み'
    }
    $('#js-cf-is-register').val([defaultRadio])

    // 確認画面へ
    $('.js-cf-confirm').on('click', function () {
      console.log('testaaaaa')
      var receiptNo = lab.getReceiptNo()
      $('#js-cf-receipt-no').val(receiptNo)
      $('#js-cf-receipt-no-txt').text(receiptNo)
      $('#js-cf-design-text').val(lab.getDesignText())
      $('#js-cf-cart-items').val(lab.getProductsInfo())

      lab.form2obj()

      if (lab.validateCF() === false) {
        lab.setErrors()
        return false
      }
      console.log('testaiu')

      lab.confirm()
      $('.page-cf__input').hide()
      $('.page-cf__confirm').show()
    })

    // 入力画面へ戻る
    $('.js-cf-back').on('click', function () {
      $('.page-cf__input').show()
      $('.page-cf__confirm').hide()
    })

    // 送信する
    $('.js-cf-submit').on('click', function () {
      location.hash = '#complete'

      lab.submitCF()

      setTimeout(function () {
        lab.clean()
// window.close()
        location.href = "/pages/jfioewjrf898ry298ry3298ryh298hf32f2fj0239j";
      }, 20000)

      $('.js-cf-input-confirm').hide()
      $('.js-cf-complete').show()
      $('.js-cf-hide-complete').hide()
    })
  }
})
